import { useQuery } from '@tanstack/react-query'

import { getPermissions } from 'services/permissions'

export const useHasPermissionScopes = (...scopes) =>
	useQuery({
		queryKey: ['vittude-permission-scopes', scopes.join(':')],
		queryFn: async () => {
			const response = await getPermissions()
			return (response.data?.permissions || []).some((scope) =>
				scopes.includes(scope)
			)
		}
	})
